export { SimpleGrid } from '@mantine/core'